import LoginModel from 'models/LoginModel';

LoginStore.dispatchToken = MakeShiftEmployeeDispatcher.register(LoginStore.dispatchCallback);

LoginStore.onSuccessfulLogin = function (collection, response) {
  // var app = React.render(React.createElement(Router, {}), document.getElementById('reactContainer'));
  const loginObj = collection.first().get('data');

  // set up global jquery ajax auth token headers and global ajax
  // error handling for analytics or message handling if we need it.

  LoginStore.trigger('login:success', loginObj);
};

LoginStore.onLoginError = function (collection, error) {
  // error handling here
  LoginStore.trigger('login:error', error);
};

LoginStore.onSuccessfulIDLogin = function (collection, response) {
  LoginStore.trigger('loginID:success', response);
};

LoginStore.onLoginIDError = function (collection, error) {
  // error handling here
  LoginStore.trigger('loginID:error', error);
};
